export default {
    'this-specialty': 'هذا الاختصاص',
    'add-new-specialty': 'إضافة اختصاص جديد',
    'edit-specialty': 'تعديل الاختصاص'
}